const fakeRequest = (data) => (
  new Promise((resolve, reject) => {
    setTimeout(() => {
      Math.round(Math.random()) ? resolve(data) : reject(new Error('Network error'))
    }, 1500)
  })
)

export function fetchBook(id) {
  return fakeRequest({
    id,
    pages: [
      'http://www.thebookdesigner.com/wp-content/uploads/2010/09/The-Fob-Bible-page.jpg',
      'http://www.thebookdesigner.com/wp-content/uploads/2010/09/The-Fob-Bible-page.jpg',
      'http://www.thebookdesigner.com/wp-content/uploads/2010/09/The-Fob-Bible-page.jpg',
    ]
  });
}



// WEBPACK FOOTER //
// ./src/api.js